import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInsuerInforUsingCode } from "../store/compareview";

const InsurerLogo = (props) => {
  const { code, img } = props;

  var selected = useSelector(
    (state) => state.entities.quotes.insurerdetails[code]
  );
  const selectedbk = useSelector(getInsuerInforUsingCode({ insurercode:code }));

  if(!selected && img){
    selected = {};
    selected.image = img;
  }
  let waitSeconds = 30;
  if (waitSeconds in props) waitSeconds = props.waitSeconds;
  const [show, setShow] = useState(false);
  var src = process.env.REACT_APP_BASICSERVICE +"/static/media/insurers/" +code +".png"

  if(selected?.image) {
    src = 'data:image/png;base64,'+selected.image
  }
  if(selected?.s3image){
    src = selected.s3image?.Location
  }
  if(selectedbk?.s3image){
    src = selectedbk.s3image?.Location
  }
  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), waitSeconds);
    return () => clearTimeout(timeout);
  });

  return (
    <React.Fragment>
      {show ? (
        <img
          style={{
            height: "100%",
          }}
          src={src}
          alt={""}
        />
      ) : (
        <div
          style={{
            width: "100%",
            fontFamily: "GibsonRegular",
            color: "grey",
            alignContent: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          Fetching Logo...
        </div>
      )}
    </React.Fragment>
  );
};

export default InsurerLogo;
